import React from "react";

import { SvgGuitarPartyLogo } from '../svg';
import { closeModal } from "../../api/modals/actions";
import { formatAmount, intervalLabel, formatDate } from "../subscription/helpers";


/*
 * Last step of the subscription modal: confirmation after an embedded
 * checkout (V2 contract) or after a card update.
 */
class PaymentDone extends React.Component {

  renderContractSummary(contract) {
    let charge = `${formatAmount(contract.amount, contract.currency)} ${intervalLabel(contract.interval, contract.interval_count)}`
    if (contract.is_on_trial) {
      return (
        <p>
          {interpolate(gettext('Your trial ends on %s. After that we will charge your card %s.'), [formatDate(contract.trial_end_at), charge])}
          {' '}{gettext('To stop the subscription, check out the settings page.')}
        </p>
      )
    }
    if (contract.next_billing_at) {
      return (
        <p>
          {interpolate(gettext('We will charge your card %s. Next payment: %s.'), [charge, formatDate(contract.next_billing_at)])}
          {' '}{gettext('To stop the subscription, check out the settings page.')}
        </p>
      )
    }
    return (
      <p>
        {contract.interval === 'year' ? gettext('We will charge your card yearly from now on.') : gettext('We will charge your card monthly from now on.')}
        {' '}{gettext('To stop the subscription, check out the settings page.')}
      </p>
    )
  }

  render() {
    let { user, subscription } = this.props
    let contract = user.contract
    let justSubscribed = subscription.checkoutCompleted

    return (
      <>
        <div className="modal-body payment-info-modal payment-done">
          <a className="logo-container" href="/">
            <SvgGuitarPartyLogo />
          </a>
          {this.props.stepIndicator}
          <div className="row justify-content-center">
            <div className="col-8">
              <h5 className="modal-title" id="exampleModalLabel">{justSubscribed ? gettext("You're subscribed!") : gettext('Payment information')}</h5>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-8">
              {justSubscribed ?
                <>
                  {contract && contract.is_active ?
                    this.renderContractSummary(contract)
                    :
                    <p>{gettext('Thank you! Your subscription is being activated and will be ready in a moment.')} {gettext('To stop the subscription, check out the settings page.')}</p>
                  }
                </>
                :
                <p>{gettext('Your credit card has been updated.')}</p>
              }
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn" onClick={() => this.props.dispatch(closeModal("modal-subscription"))}>{gettext('Close')}</button>
        </div>
      </>
    )
  }
}

export default PaymentDone;
